import type { CpOrderCancelResponse } from 'apiConnector/secondary-market/cp-order/model';
import { secondaryMarketCancellationActionsFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.actions';

export const cpOrderCancellationActions = secondaryMarketCancellationActionsFactory<CpOrderCancelResponse, 'CP_ORDER'>(
  'CP_ORDER',
);
type TypeofCpOrderCancellationActions = typeof cpOrderCancellationActions;
export type SecondaryMarketCpOrderCancellationWorkflowInit = ReturnType<
  TypeofCpOrderCancellationActions['secondaryMarketCancellationWorkflowInit']
>;
export type SecondaryMarketCpOrderCancellationWorkflowAborted = ReturnType<
  TypeofCpOrderCancellationActions['secondaryMarketCancellationWorkflowAborted']
>;
export type SecondaryMarketCpOrderCancellationWorkflowCompleted = ReturnType<
  TypeofCpOrderCancellationActions['secondaryMarketCancellationWorkflowCompleted']
>;
export type SecondaryMarketCpOrderCancellationRequested = ReturnType<
  TypeofCpOrderCancellationActions['secondaryMarketCancellationRequested']
>;
export type SecondaryMarketCpOrderCancellationReceived = ReturnType<
  TypeofCpOrderCancellationActions['secondaryMarketCancelReceived']
>;
export type SecondaryMarketCpOrderCancellationRejected = ReturnType<
  TypeofCpOrderCancellationActions['secondaryMarketCancellationRejected']
>;
export type SecondaryMarketCpOrderCancellationFailed = ReturnType<
  TypeofCpOrderCancellationActions['secondaryMarketCancellationFailed']
>;
export type SecondaryMarketCpOrderCancellationsActions = ReturnType<
  TypeofCpOrderCancellationActions[keyof TypeofCpOrderCancellationActions]
>;
export type CpOrderCancellationActions = typeof cpOrderCancellationActions;
